export default __webpack_public_path__ + "static/media/logoWithShadow.63e7d06d.svg";